<lib-survey-layout>
  <lib-survey
    (surveyLoad)="onSurveyLoad()"
    (pageChanged)="onPageChange()"
    (submitted)="onSubmit()"
    [options]="{
      submitOnLastQuestion: true,
      submitLabel: (template$ | async)?.submitLabel ?? 'Valider'
    }"
  >
    <ng-template libSurveyOutro>
      <lib-evaluate-submit></lib-evaluate-submit>
    </ng-template>
  </lib-survey>
</lib-survey-layout>
